import React from 'react';
import { compose } from 'ramda';
import Grid from '@material-ui/core/Grid';
import Forms from 'components/Forms';
import { OrganizationType } from 'store/modules/auth/auth';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { withMetaDescription } from 'components/HeadProvider/HeadProvider';

const { connect, selectors } = StoreProvider;

interface InviteRepondentProps {
  organization: OrganizationType;
  uuid: string;
  codename: string;
  setRespondentsAdded: (val: boolean) => void;
}

const ProjectInviteRespondents = ({
  organization,
  uuid,
  codename,
  setRespondentsAdded,
}: InviteRepondentProps) => {
  const organizationCodename = codename || organization.codename;

  return (
    <Grid container>
      <Grid item xs={12}>
        <Forms.UploadPanelistEmails
          organizationCodename={organizationCodename}
          uuid={uuid}
          setRespondentsAdded={setRespondentsAdded}
        />
      </Grid>
    </Grid>
  );
};

export default compose(
  connect((state) => ({
    organization: selectors.authSelectors.userOrganization(state),
  })),
  withMetaDescription({ title: 'Dashboard projects' })
)(ProjectInviteRespondents);
